<div class="card" *ngIf="loading">
  <div class="card-body d-flex justify-content-center">
    <i class="fas fa-spinner fa-spin fa-3x"></i>
  </div>
</div>

<div class="card" *ngIf="!loading">
  <div class="card-header">
    <h5 class="card-title">PAGE NOT FOUND</h5>
  </div>
  <div class="card-body">
    <p>The page you are looking for could not be found. The page may not exist or may have moved.</p>
    <p>If you continue to experience an issue, please contact support</p>

    <div>
      <a *ngIf="authService.isAuthenticated()" routerLink="/private" class="btn btn-primary">Return to My Dashboard</a>
      <a *ngIf="!authService.isAuthenticated()" routerLink="/login" class="btn btn-primary">Return to Login</a>
    </div>
  </div>
</div>
